// Test IDs for the "How It Works" animated workflow comparison feature
// (homepage teaser + dedicated /how-it-works page).
// Keys camelCase, values kebab-case `<feature>-<element>`.

export const HOW_IT_WORKS = {
  // Homepage teaser band
  teaserSection: 'home-how-it-works-teaser-section',
  teaserPrimaryCta: 'home-how-it-works-primary-cta',
  teaserVoiceCta: 'home-how-it-works-voice-cta',
  teaserMiniPreview: 'home-how-it-works-mini-preview',

  // Hero
  hero: 'how-it-works-hero',
  heroPrimaryCta: 'how-it-works-hero-primary-cta',
  heroSecondaryCta: 'how-it-works-hero-secondary-cta',

  // Audience toggle
  audienceToggle: 'how-it-works-audience-toggle',
  audienceClient: 'how-it-works-audience-client',
  audiencePhotographer: 'how-it-works-audience-photographer',

  // Dual-track timeline
  timelineSection: 'how-it-works-timeline',
  stageRow: (slug) => `how-it-works-stage-row-${slug}`,
  traditionalCard: (slug) => `how-it-works-traditional-card-${slug}`,
  lxraCard: (slug) => `how-it-works-lxra-card-${slug}`,
  stageNode: (slug) => `how-it-works-stage-node-${slug}`,

  // Voice guide
  voiceSection: 'how-it-works-voice-guide',
  voicePlayPause: 'how-it-works-voice-play-pause',
  voiceStop: 'how-it-works-voice-stop',
  voicePrev: 'how-it-works-voice-prev',
  voiceNext: 'how-it-works-voice-next',
  voiceProgress: 'how-it-works-voice-progress',
  voiceStageButton: (slug) => `how-it-works-voice-stage-${slug}`,
  voiceAudienceBadge: 'how-it-works-voice-audience-badge',
  voiceComingSoonBadge: 'how-it-works-voice-coming-soon-badge',

  // Platform tour
  tourSection: 'how-it-works-platform-tour',
  tourCarousel: 'how-it-works-platform-tour-carousel',
  tourPrev: 'how-it-works-platform-tour-prev',
  tourNext: 'how-it-works-platform-tour-next',
  tourSlide: (slug) => `how-it-works-platform-tour-slide-${slug}`,
  tourSlideTitle: 'how-it-works-platform-tour-slide-title',

  // Closing CTA
  closingSection: 'how-it-works-closing-cta',
  closingPrimary: 'how-it-works-closing-primary-cta',
  closingSecondary: 'how-it-works-closing-secondary-cta',
};
